module.exports = __webpack_public_path__ + "files/sharepoint-3-configuration.51ad0208.pdf";